import React from 'react';
import { VerificationMetadataProps } from '../../types/VerificationTypes';
import { Shield, Clock, Hash, CheckCircle, XCircle } from 'lucide-react';

const VerificationMetadata: React.FC<VerificationMetadataProps> = ({ 
  verificationInfo, 
  security 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-xl font-semibold text-charcoal-ink mb-6">Verification Metadata</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column - Verification Information */}
        <div>
          <h4 className="text-lg font-medium text-charcoal-ink mb-4">Verification Information</h4>
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <Clock className="h-5 w-5 text-warm-slate" />
              <div>
                <p className="text-sm text-warm-slate mb-1">Verified At</p>
                <p className="font-medium text-charcoal-ink">
                  {new Date(verificationInfo.verified_at).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <Hash className="h-5 w-5 text-warm-slate" />
              <div>
                <p className="text-sm text-warm-slate mb-1">Verification ID</p>
                <p className="font-mono text-sm text-charcoal-ink">{verificationInfo.verification_id}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3">
              <Shield className="h-5 w-5 text-warm-slate" />
              <div>
                <p className="text-sm text-warm-slate mb-1">Verification URL</p>
                <p className="font-mono text-sm text-charcoal-ink break-all">
                  {verificationInfo.verification_url}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Right Column - Security Information */}
        {security && (
          <div>
            <h4 className="text-lg font-medium text-charcoal-ink mb-4">Security Information</h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Hash className="h-5 w-5 text-warm-slate" />
                <div>
                  <p className="text-sm text-warm-slate mb-1">Checksum</p>
                  <p className="font-mono text-sm text-charcoal-ink break-all">
                    {security.checksum}
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                {security.signature_valid ? (
                  <CheckCircle className="h-5 w-5 text-verified-green" />
                ) : (
                  <XCircle className="h-5 w-5 text-red-500" />
                )}
                <div>
                  <p className="text-sm text-warm-slate mb-1">Digital Signature</p>
                  <p className={`font-medium ${
                    security.signature_valid ? 'text-verified-green' : 'text-red-500'
                  }`}>
                    {security.signature_valid ? 'Valid' : 'Invalid'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationMetadata; 